import React from 'react';
import {Tooltip} from "antd";
import styles from "./style.module.scss";
import {openNote} from "../../../../../../components/Popup/PopupOpNote";
import Icon, {ICON_NAME} from "../../../../../../components/Icon";

const propsNote = {
    align: {offset: [0, 6]},
    mouseEnterDelay: 0.03
}

interface IProps {
    value?: string
    title?: string
    isBubble?: boolean
    isContent?: boolean
    isLabel?: boolean
    isTooltip?: boolean

    onChange(value: string): void
}

const AddNote: React.FC<IProps> = ({
                                       title = '',
                                       value,
                                       isBubble = true,
                                       isContent,
                                       isLabel = true,
                                       isTooltip = false,
                                       onChange
                                   }) => {
    const handleOpenNote = (note: string = '') => {
        openNote({title, note, onSave: onChange})
    }

    const isNote = (value || '').trim().length > 0;
    const content = <div className='flex items-center'>
        <div
            className='bt-ghost relative'
            data-icon='true'
            data-is-note={isNote}
            title={isNote ? "" : "Click to add notes for " + title}
            onClick={() => handleOpenNote(value)}
        >
            <div className='flex items-center px-[8px]'>
                {isLabel && <div className='mr-1'>Add note</div>}
                <Icon className={styles.note} icon={ICON_NAME.NOTE}/>
                {isBubble && <div className={styles.noted} data-is-note={isNote}/>}
            </div>
        </div>
        {isContent && <div>{value}</div>}
    </div>;

    if (!isTooltip)
        return content

    return <Tooltip {...propsNote} title={isNote ? `Note: ${value}` : ''}>
        {content}
    </Tooltip>;
};

export default AddNote;
